import { useState, useCallback } from 'react'
import Icon from '@components/shared/Icon'
import mix from '@utils/styles/mix'
import styles from './Alert.module.css'

export default function Alert ({ children, className }) {
    const [show, setShow] = useState(true)
    const hide = useCallback(() => setShow(false), [])

    if (!show) return null
    return (
        <div className={mix([styles.alert, className])}>
            <span>{children}</span>
            <span onClick={hide}><Icon>close</Icon></span>
        </div>
    )
}